import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import { useSetNotification } from '../../../context/Notification';
import useRequest from '../../../hooks/useRequest';
import { ORGANIZATION_MEMBER_KEY } from './constants';

type Payload = {
    member_id: number;
};

const useMemberSendMonthlyCallReminder = () => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = (payload: Payload) => {
        return req({
            url: `${envVars.API_COMMERCE_HOSTNAME}enterprise/disengaged-member/reminder/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_KEY] });
            setNotification({ message: `Monthly Call Reminder sent` });
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useMemberSendMonthlyCallReminder;
